import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  faFont,
  // faFileContract,
  faAd,
  faTextHeight,
  faMicrophone,
  // faCalendarAlt,
  faExternalLinkAlt,
  faCompressAlt,
  faEyeDropper,
  faEnvelope,
  faHome,
  faCalculator,
  faTable,
  faSpellCheck,
  faPercentage,
  faQrcode,
  faKey,
  faBackspace,
  faCut,
  faVolumeUp,
  faFileImage,
  faFileWord,
  faFilePowerpoint,
  faFileExcel,
  faFilePdf,
  faExchangeAlt,
  faCode,
  faDatabase,
  faUnlock,
  faPalette,
  faUnlockKeyhole,
  faLockOpen,
  // faReceipt,
  // faMobileScreen
} from '@fortawesome/free-solid-svg-icons';

const tools = [
  {
    id: 1,
    title: "Fancy Text Generator",
    path: "fancy-text-generator",
    icon: <FontAwesomeIcon icon={faFont} />,
    iconColor: "#8b5cf6",
    description: "Add stylish fonts to your social posts, bios, and messages.",
    category: "Designing"
  },
  /* {
    id: 2,
    title: "Social media mockup generator",
    path: "social-media-mockup-generator",
    icon: <FontAwesomeIcon icon={faMobileScreen} />,
    iconColor: "#8b5cf6",
    description: "Create realistic social media mockups for Instagram, Facebook, and Twitter.",
    category: "Designing"
  }, */
  /* {
    id: 3,
    title: "Policies Terms",
    path: "policies-terms",
    icon: <FontAwesomeIcon icon={faFileContract} />,
    iconColor: "#3b82f6",
    description: "Generate privacy policies, terms of service, and disclaimers for websites and apps.",
    category: "Development"
  }, */
  {
    id: 4,
    title: "Loan Amortization Calculator",
    path: "loan-amortization-calculator",
    icon: <FontAwesomeIcon icon={faTable} />,
    iconColor: "#3b82f6",
    description: "Plan loan repayments with a detailed amortization schedule.",
    category: "Development"
  },
  {
    id: 5,
    title: "Voice Recorder Online",
    path: "voice-recorder-online",
    icon: <FontAwesomeIcon icon={faMicrophone} />,
    iconColor: "#f97316",
    description: "Record high-quality audio directly from your browser with no software needed.",
    category: "Productivity"
  },
  /* {
    id: 6,
    title: "Calendar Share Link",
    path: "calendar-share",
    icon: <FontAwesomeIcon icon={faCalendarAlt} />,
    iconColor: "#3b82f6",
    description: "Simplify scheduling by generating shareable calendar links for meetings.",
    category: "Development"
  }, */
  {
    id: 7,
    title: "Multi URL Opener",
    path: "multi-url-opener",
    icon: <FontAwesomeIcon icon={faExternalLinkAlt} />,
    iconColor: "#3b82f6",
    description: "Open multiple links at once with a single click for faster browsing.",
    category: "Development"
  },
  /* {
    id: 8,
    title: "Invoice Generator",
    path: "invoice-generator",
    icon: <FontAwesomeIcon icon={faReceipt} />,
    iconColor: "#10b981", 
    description: "Generate professional invoices with customizable templates.",
    category: "Marketing"
  }, */
  {
    id: 9,
    title: "Image Compressor",
    path: "compress-image",
    icon: <FontAwesomeIcon icon={faCompressAlt} />,
    iconColor: "#8b5cf6",
    description: "Compress images without losing visible quality for faster web loading.",
    category: "Designing"
  },
  {
    id: 10,
    title: "Color Picker",
    path: "color-picker",
    icon: <FontAwesomeIcon icon={faEyeDropper} />,
    iconColor: "#8b5cf6",
    description: "Extract, match, and generate HEX, RGB, and HSL color codes easily.",
    category: "Designing"
  },
  {
    id: 11,
    title: "Email Validator",
    path: "email-validator",
    icon: <FontAwesomeIcon icon={faEnvelope} />,
    iconColor: "#ef4444",
    description: "Check email validity and deliverability to reduce bounce rates.",
    category: "Security"
  },
  {
    id: 12,
    title: "Mortage Calculator",
    path: "mortage-calculator",
    icon: <FontAwesomeIcon icon={faHome} />,
    iconColor: "#3b82f6",
    description: "Calculate mortgage payments based on loan amount, rate, and term.",
    category: "Development"
  },
  {
    id: 13,
    title: "Loan Calculator",
    path: "loan-calculator",
    icon: <FontAwesomeIcon icon={faCalculator} />,
    iconColor: "#3b82f6",
    description: "Estimate loan repayment amounts, interest, and total cost.",
    category: "Development"
  },
  {
    id: 14,
    title: "Google Ads Calculator",
    path: "google-ads-calculator",
    icon: <FontAwesomeIcon icon={faAd} />,
    iconColor: "#10b981",
    description: "Estimate ad spend, clicks, conversions, and ROI for Google Ads campaigns.",
    category: "Marketing"
  },
  {
    id: 15,
    title: "Num to Words",
    path: "num-to-words",
    icon: <FontAwesomeIcon icon={faSpellCheck} />,
    iconColor: "#f97316",
    description: "Convert numeric values into their corresponding word formats.",
    category: "Converter"
  },
  {
    id: 16,
    title: "Percentage Calculator",
    path: "percentage-calculator",
    icon: <FontAwesomeIcon icon={faPercentage} />,
    iconColor: "#3b82f6",
    description: "Quickly compute percentage increases, decreases, and differences.",
    category: "Development"
  },
  {
    id: 17,
    title: "QR Code Generator",
    path: "qr-code-generator",
    icon: <FontAwesomeIcon icon={faQrcode} />,
    iconColor: "#10b981",
    description: "Create high-quality QR codes for URLs, contact info, and more.",
    category: "Marketing"
  },
  {
    id: 18,
    title: "Random Password Generator",
    path: "random-password-generator",
    icon: <FontAwesomeIcon icon={faKey} />,
    iconColor: "#ef4444",
    description: "Generate strong, secure passwords in seconds for better security.",
    category: "Security"
  },
  {
    id: 19,
    title: "Remove Duplicate Elements",
    path: "remove-duplicate",
    icon: <FontAwesomeIcon icon={faBackspace} />,
    iconColor: "#3b82f6",
    description: "Clean up text or data lists by removing duplicate entries.",
    category: "Development"
  },
  {
    id: 20,
    title: "Split PDF",
    path: "split-pdf",
    icon: <FontAwesomeIcon icon={faCut} />,
    iconColor: "#f97316",
    description: "Split large PDFs into smaller, manageable files easily.",
    category: "Converter"
  },
  {
    id: 21,
    title: "Text to Speech",
    path: "text-to-speach",
    icon: <FontAwesomeIcon icon={faVolumeUp} />,
    iconColor: "#f97316",
    description: "Convert written text into natural-sounding speech instantly.",
    category: "Converter"
  },
  {
    id: 22,
    title: "JPG to PNG",
    path: "jpg-to-png",
    icon: <FontAwesomeIcon icon={faFileImage} />,
    iconColor: "#f97316",
    description: "Convert JPG images to high-quality PNG format with transparency.",
    category: "Converter"
  },
  {
    id: 23,
    title: "PNG to JPG",
    path: "png-to-jpg",
    icon: <FontAwesomeIcon icon={faFileWord} />,
    iconColor: "#f97316",
    description: "Convert PNG images to JPG format for smaller file sizes.",
    category: "Converter"
  },
  {
    id: 24,
    title: "HEIC to JPG",
    path: "heic-to-jpg",
    icon: <FontAwesomeIcon icon={faFilePowerpoint} />,
    iconColor: "#f97316",
    description: "Convert HEIC images (iPhone) to widely compatible JPG format.",
    category: "Converter"
  },
  {
    id: 25,
    title: "WebP to JPG",
    path: "webp-to-jpg-converter",
    icon: <FontAwesomeIcon icon={faFileExcel} />,
    iconColor: "#f97316",
    description: "Convert WebP images to high-quality JPG format for compatibility.",
    category: "Converter"
  },
  {
    id: 26,
    title: "Word to JPG",
    path: "word-to-jpg-converter",
    icon: <FontAwesomeIcon icon={faFilePdf} />,
    iconColor: "#f97316",
    description: "Convert Word documents to JPG images for easy sharing.",
    category: "Converter"
  },
  // {
  //   id: 27,
  //   title: "JPEG to Word",
  //   path: "jpeg-to-word-converter",
  //   icon: <FontAwesomeIcon icon={faExchangeAlt} />,
  //   iconColor: "#f97316",
  //   description: "Convert JPEG images to editable Word documents (OCR-based).",
  //   category: "Converter"
  // },
  // {
  //   id: 28,
  //   title: "PDF to Word",
  //   path: "pdf-to-word-converter",
  //   icon: <FontAwesomeIcon icon={faCode} />,
  //   iconColor: "#f97316",
  //   description: "Convert PDF files to editable Word documents for easy editing.",
  //   category: "Converter"
  // },
  // {
  //   id: 29,
  //   title: "Ppt to PDF",
  //   path: "ppt-to-pdf-converter",
  //   icon: <FontAwesomeIcon icon={faDatabase} />,
  //   iconColor: "#f97316",
  //   description: "Convert PowerPoint presentations to PDF for universal viewing.",
  //   category: "Converter"
  // },
  // {
  //   id: 30,
  //   title: "Excel to PDF",
  //   path: "excel-to-pdf-converter",
  //   icon: <FontAwesomeIcon icon={faUnlock} />,
  //   iconColor: "#f97316",
  //   description: "Convert Excel spreadsheets to PDF for secure sharing.",
  //   category: "Converter"
  // },
  {
    id: 31,
    title: "Pdf To Jpg",
    path: "pdf-to-jpg-converter",
    icon: <FontAwesomeIcon icon={faUnlock} />,
    iconColor: "#f97316",
    description: "Convert PDF pages to high-quality JPG images for flexibility.",
    category: "Converter"
  },
  {
    id: 32,
    title: "Jpg To Pdf",
    path: "jpg-to-pdf-converter",
    icon: <FontAwesomeIcon icon={faPalette} />,
    iconColor: "#f97316",
    description: "Convert JPG images to PDF for easy document consolidation.",
    category: "Converter"
  },
  {
    id: 33,
    title: "Pdf Merger",
    path: "pdf-merger",
    icon: <FontAwesomeIcon icon={faFilePdf} />,
    iconColor: "#f97316",
    description: "Merge multiple PDF files into a single document easily.",
    category: "Converter"
  },
  {
    id: 34,
    title: "Word to jpeg",
    path: "word-to-jpeg-converter",
    icon: <FontAwesomeIcon icon={faFileImage} />,
    iconColor: "#f97316",
    description: "Convert Word documents to JPEG images for compatibility.",
    category: "Converter"
  },
  {
    id: 35,
    title: "Webp To Jpeg",
    path: "webp-to-jpeg-convert",
    icon: <FontAwesomeIcon icon={faFileImage} />,
    iconColor: "#f97316",
    description: "Convert WebP images to JPEG format for wider support.",
    category: "Converter"
  },
  {
    id: 36,
    title: "Binary to Decimal",
    path: "binary-to-decimal",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert binary numbers (e.g., 1010) to decimal format (e.g., 10).",
    category: "Converter"
  },
  {
    id: 37,
    title: "Binary to Hex",
    path: "binary-to-hex",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert binary numbers to hexadecimal (e.g., 1010 → A).",
    category: "Converter"
  },
  {
    id: 38,
    title: "Binary to Octal",
    path: "binary-to-octal",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert binary values to octal format (e.g., 1010 → 12).",
    category: "Converter"
  },
  {
    id: 39,
    title: "Binary to String",
    path: "binary-to-string",
    icon: <FontAwesomeIcon icon={faCode} />,
    iconColor: "#f97316",
    description: "Decode binary values (e.g., 01001000) into readable text.",
    category: "Converter"
  },
  {
    id: 40,
    title: "Decimal to Binary",
    path: "decimal-to-binary",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert decimal numbers (e.g., 10) to binary (e.g., 1010).",
    category: "Converter"
  },
  {
    id: 41,
    title: "Decimal to Hex",
    path: "decimal-to-hex",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert decimal numbers to hexadecimal (e.g., 255 → FF).",
    category: "Converter"
  },
  {
    id: 42,
    title: "Decimal to Octal",
    path: "decimal-to-octal",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert decimal numbers to octal (e.g., 10 → 12).",
    category: "Converter"
  },
  {
    id: 43,
    title: "Hex to Binary",
    path: "hex-to-binary",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert hexadecimal (e.g., A) to binary (e.g., 1010).",
    category: "Converter"
  },
  {
    id: 44,
    title: "Hex to Decimal",
    path: "hex-to-decimal",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert hex values (e.g., FF) to decimal (e.g., 255).",
    category: "Converter"
  },
  {
    id: 45,
    title: "Hex to Octal",
    path: "hex-to-octal",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert hexadecimal (e.g., A) to octal (e.g., 12).",
    category: "Converter"
  },
  {
    id: 46,
    title: "Data Size",
    path: "data-size-converter",
    icon: <FontAwesomeIcon icon={faDatabase} />,
    iconColor: "#f97316",
    description: "Convert between KB, MB, GB, TB, and other data units.",
    category: "Converter"
  },
  {
    id: 47,
    title: "MD5 Hash Generator",
    path: "md5-hash",
    icon: <FontAwesomeIcon icon={faUnlockKeyhole} />,
    iconColor: "#ef4444",
    description: "Generate MD5 hashes for text to verify data integrity.",
    category: "Security"
  },
  {
    id: 48,
    title: "Octal to Binary",
    path: "octal-to-binary",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert octal numbers (e.g., 12) to binary (e.g., 1010).",
    category: "Converter"
  },
  {
    id: 49,
    title: "Octal to Decimal",
    path: "octal-to-decimal",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert octal values (e.g., 12) to decimal (e.g., 10).",
    category: "Converter"
  },
  {
    id: 50,
    title: "Octal to Hex",
    path: "octal-to-hex",
    icon: <FontAwesomeIcon icon={faExchangeAlt} />,
    iconColor: "#f97316",
    description: "Convert octal numbers (e.g., 12) to hex (e.g., A).",
    category: "Converter"
  },
  {
    id: 51,
    title: "RGB to Hex",
    path: "rgb-to-hex",
    icon: <FontAwesomeIcon icon={faPalette} />,
    iconColor: "#8b5cf6",
    description: "Convert RGB color codes (e.g., 255,0,0) to hex (e.g., #FF0000).",
    category: "Designing"
  },
  {
    id: 52,
    title: "String to Binary",
    path: "string-to-binary",
    icon: <FontAwesomeIcon icon={faCode} />,
    iconColor: "#f97316",
    description: "Encode text strings (e.g., 'Hi') into binary (e.g., 01001000).",
    category: "Converter"
  },
  {
    id: 53,
    title: "SHA1 Hash Generator",
    path: "sha1-hash",
    icon: <FontAwesomeIcon icon={faUnlockKeyhole} />,
    iconColor: "#ef4444",
    description: "Generate SHA1 hashes for secure data verification.",
    category: "Security"
  },
  {
    id: 54,
    title: "SHA256 Hash Generator",
    path: "sha256-hash",
    icon: <FontAwesomeIcon icon={faUnlockKeyhole} />,
    iconColor: "#ef4444",
    description: "Create SHA256 hashes for cryptographic security.",
    category: "Security"
  },
  {
    id: 55,
    title: "SHA512 Hash Generator",
    path: "sha512-hash",
    icon: <FontAwesomeIcon icon={faUnlockKeyhole} />,
    iconColor: "#ef4444",
    description: "Generate strong SHA512 hash values for data security.",
    category: "Security"
  },
  {
    id: 56,
    title: "Word Count",
    path: "word-count",
    icon: <FontAwesomeIcon icon={faFont} />,
    iconColor: "#3b82f6",
    description: "Count words, characters, and sentences in your text.",
    category: "Development"
  },
  {
    id: 57,
    title: "Base64 Decode",
    path: "base-64-decode",
    icon: <FontAwesomeIcon icon={faLockOpen} />,
    iconColor: "#ef4444",
    description: "Decode Base64-encoded text back to its original form.",
    category: "Security"
  },
  {
    id: 58,
    title: "Base64 Encode",
    path: "base-64-encode",
    icon: <FontAwesomeIcon icon={faUnlock} />,
    iconColor: "#ef4444",
    description: "Encode plain text into Base64 format for data safety.",
    category: "Security"
  },
  {
    id: 59,
    title: "Text to Handwriting",
    path: "text-to-handwriting",
    icon: <FontAwesomeIcon icon={faFont} />,
    iconColor: "#3b82f6",
    description: "Convert text into handwritten-style images.",
    category: "Designing"
  },
  {
    id: 60,
    title: "Case Converter",
    path: "case-converter",
    icon: <FontAwesomeIcon icon={faTextHeight} />,
    iconColor: "#3b82f6",
    description: "Convert your text into uppercase, lowercase, sentence case, title case, and more instantly with a single click.",
    category: "Designing"
  },
  {
    id: 61,
    title: "Letter Counter",
    path: "letter-counter",
    icon: <FontAwesomeIcon icon={faTextHeight} />,
    iconColor: "#3b82f6",
    description: "Count letters, words, and sentences in your text.",
    category: "Designing"
  },
  {
    id: 62,
    title: "Lorem Ipsum Generator",
    path: "lorem-ipsum-generator",
    icon: <FontAwesomeIcon icon={faTextHeight} />,
    iconColor: "#3b82f6",
    description: "Generate placeholder text instantly for mockups, wireframes, and drafts. ",
    category: "Designing"
  },
  {
    id: 63,
    title: "Bionic Reading Converter",
    path: "bionic-reading-converter",
    icon: <FontAwesomeIcon icon={faTextHeight} />,
    iconColor: "#3b82f6",
    description: "Convert text into bionic reading-style images.",
    category: "Designing"
  },
  {
    id: 64,
    title: "Whitespace Remover",
    path: "whitespace-remover",
    icon: <FontAwesomeIcon icon={faTextHeight} />,
    iconColor: "#3b82f6",
    description: "Remove extra spaces and whitespace from your text.",
    category: "Designing"
  },
  // {
  //   id: 65,
  //   title: "Font Pair Finder",
  //   path: "font-pair-finder",
  //   icon: <FontAwesomeIcon icon={faTextHeight} />,
  //   iconColor: "#3b82f6",
  //   description: "Find the perfect font pair for your design.",
  //   category: "Designing"
  // },
  {
    id: 66,
    title: "Gitignore Generator",
    path: "gitignore-generator",
    icon: <FontAwesomeIcon icon={faTextHeight} />,
    iconColor: "#3b82f6",
    description: "Generate .gitignore files for your projects.",
    category: "Development"
  },
  // {
  //   id: 67,
  //   title: "Sorting Visualizer",
  //   path: "sorting-visualizer",
  //   icon: <FontAwesomeIcon icon={faTextHeight} />,
  //   iconColor: "#3b82f6",
  //   description: "Visualize sorting algorithms in action.",
  //   category: "Development"
  // },
  // {
  //   id: 68,
  //   title: "Message Segment Tool",
  //   path: "message-segment-tool",
  //   icon: <FontAwesomeIcon icon={faTextHeight} />,
  //   iconColor: "#3b82f6",
  //   description: "Calculate message segments for SMS.",
  //   category: "Development"
  // },
  {
    id: 69,
    title: "Campaign URL Builder",
    path: "campaign-url-builder",
    icon: <FontAwesomeIcon icon={faTextHeight} />,
    iconColor: "#3b82f6",
    description: "Build campaign URLs for email marketing.",
    category: "Development"
  },
];

export default tools;